import { useState } from 'react';
import '../assets/styles/TrackShipment.css';

function TrackShipment() {
  const [trackingNumber, setTrackingNumber] = useState('');
  const [alert, setAlert] = useState({ show: false, type: '', message: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!trackingNumber.trim()) {
      setAlert({
        show: true,
        type: 'danger',
        message: 'Please enter a valid tracking number.',
      });
      setTimeout(() => setAlert({ show: false, type: '', message: '' }), 3000);
      return;
    }
    // Simulate API call for tracking info
    setAlert({
      show: true,
      type: 'success',
      message: `Tracking number ${trackingNumber} submitted! Check your shipment status.`,
    });
    setTrackingNumber(''); // Clear input
    setTimeout(() => setAlert({ show: false, type: '', message: '' }), 3000);
    // Replace with actual API call to backend for tracking info
  };

  return (
    <section id="track-shipment" className="track-section py-5">
      <div className="container">
        <h2 className="track-title fw-bold text-center mb-4">Track Your Shipment</h2>
        <div className="track-form-container mt-4 mx-auto">
          {alert.show && (
            <div className={`alert alert-${alert.type} alert-dismissible fade show`} role="alert">
              {alert.message}
              <button
                type="button"
                className="btn-close"
                onClick={() => setAlert({ show: false, type: '', message: '' })}
                aria-label="Close"
              ></button>
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                value={trackingNumber}
                onChange={(e) => setTrackingNumber(e.target.value)}
                placeholder="Enter tracking number"
                aria-label="Tracking number"
              />
              <button type="submit" className="btn btn-track">
                Track Shipment
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

export default TrackShipment;